import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9b17a13c")

_pushScopeId("data-v-9b17a13c")
const _hoisted_1 = {
  key: 1,
  class: "animation-index"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["operate", { 'multi-select': _ctx.isMultiSelect && !_ctx.isActive }],
    style: {
      top: _ctx.elementInfo.top * _ctx.canvasScale + 'px',
      left: _ctx.elementInfo.left * _ctx.canvasScale + 'px',
      transform: `rotate(${_ctx.elementInfo.rotate}deg)`,
      transformOrigin: `${_ctx.elementInfo.width * _ctx.canvasScale / 2}px ${_ctx.elementInfo.height * _ctx.canvasScale / 2}px`,
    }
  }, [
    (_ctx.isSelected)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentOperateComponent), {
          key: 0,
          elementInfo: _ctx.elementInfo,
          isActiveGroupElement: _ctx.isActiveGroupElement,
          isMultiSelect: _ctx.isMultiSelect,
          rotateElement: _ctx.rotateElement,
          scaleElement: _ctx.scaleElement,
          dragLineElement: _ctx.dragLineElement
        }, null, 8, ["elementInfo", "isActiveGroupElement", "isMultiSelect", "rotateElement", "scaleElement", "dragLineElement"]))
      : _createCommentVNode("", true),
    (_ctx.toolbarState === 'elAnimation' && _ctx.elementIndexInAnimation !== -1)
      ? (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString(_ctx.elementIndexInAnimation + 1), 1))
      : _createCommentVNode("", true)
  ], 6))
})